export * from './OnboardingHeader';
export default './OnboardingHeader';
